import Box from "@mui/material/Box";
import { selectQuotationForm } from "app/containers/WorkOrder/redux/selector";
import { actions } from "app/containers/WorkOrder/redux/slice";
import { QuotationFormValues } from "app/containers/WorkOrder/types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  CLOSED_ADJUSTED_HEIGHT_OPTIONS,
  CLOSED_BODY_HEIGHT_OPTIONS,
} from "../../../data";
import { formKey } from "../../../hooks/useQuoteBoxStructure";
import {
  NumberField,
  NumberedSectionTitle,
  SelectField,
} from "../OpenBoxQuotes/FormFields";
import { useStyles } from "../styles";

const closedKey = (suffix: string) => formKey(`CLOSED_BOX.${suffix}`);

const Dimensions = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const form = useSelector(selectQuotationForm);

  const updateField = (field: keyof QuotationFormValues, value: string) => {
    dispatch(actions.updateQuotationFormField({ field, value }));
  };

  return (
    <Box className={styles.inputCard}>
      <NumberedSectionTitle
        number={1}
        titleKey={closedKey("SECTIONS.DIMENSIONS")}
      />
      <Box className={styles.grid4}>
        <NumberField
          labelKey={closedKey("FIELDS.BODY_LENGTH")}
          value={form.assembledLength}
          onChange={(value) => updateField("assembledLength", value)}
        />
        <NumberField
          labelKey={closedKey("FIELDS.BODY_WIDTH")}
          value={form.assembledWidth}
          onChange={(value) => updateField("assembledWidth", value)}
        />
        <SelectField
          labelKey={closedKey("FIELDS.BODY_HEIGHT")}
          value={form.bodyHeightRange}
          options={CLOSED_BODY_HEIGHT_OPTIONS}
          onChange={(value) => updateField("bodyHeightRange", value)}
        />
        <SelectField
          labelKey={closedKey("FIELDS.ADJUSTED_HEIGHT")}
          value={form.adjustedHeight}
          options={CLOSED_ADJUSTED_HEIGHT_OPTIONS}
          onChange={(value) => updateField("adjustedHeight", value)}
        />
      </Box>
    </Box>
  );
};

export default Dimensions;
